import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private
        exact
        key="samplelog"
        path="/sample-log"
        component={Page} />
];

export default Routes;
